/**
 * 对象中去掉空的字段，一般请求接口的参数处理用到
 * @param data
 * @returns
 */
export const piOhForNull = (data) => {
    const json = {};
    for (const i in data) {
        if (data[i] !== "" && data[i] !== undefined) {
            json[i] = data[i];
        }
    }
    return json;
};
/**
 *
 * @param array 判断数组是否重复
 * @returns true false
 */
export const piOhHasDuplicateStrings = (array) => {
    const set = new Set(array);
    return set.size !== array.length;
};
/**
 * 深层合并对象
 * @param obj1 对象 1
 * @param obj2 对象 2
 * @returns  新对象
 */
export const piOhDeepMerge = (obj1, obj2) => {
    // 遍历obj2的属性
    for (const key in obj2) {
        // 如果obj2的属性是一个对象，且obj1也有相同的属性，则递归合并这两个对象
        if (typeof obj2[key] === "object" &&
            Object.prototype.hasOwnProperty.call(obj1, key) &&
            typeof obj1[key] === "object") {
            obj1[key] = piOhDeepMerge(obj1[key], obj2[key]);
        }
        else {
            // 否则，直接将obj2的属性赋值给obj1
            obj1[key] = obj2[key];
        }
    }
    return obj1;
};
/**
 * 获取百分比
 * @param value 当前值
 * @param total 总数
 * @param fixed 保留几位小数，默认两位
 * @returns 百分比 10%
 */
export const piOhGetProgress = (value, total, fixed) => {
    fixed = fixed || 2;
    return total > 0
        ? parseFloat(((value / total) * 100).toFixed(fixed)) + "%"
        : "0%";
};
/**
 * 把 对象 转成 a=1&b=2 格式
 * @param json 对象
 * @returns a=1&b=2
 */
export const piOhParseParam = (json) => {
    const params = Object.keys(json)
        .map(function (key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
    })
        .join("&");
    return params;
};
/**
 * 数字数组排序
 * @param arr  [10,8]
 * @param type 传 升序排列   不传降序排列
 * @returns 排列过的数组
 */
export const piOhSortNumber = (arr, type) => {
    return arr.sort(function (a, b) {
        if (type) {
            return a - b; // —>升序排列
        }
        else {
            return b - a; //降序排列，
        }
    });
};
/**
 * 对象数组排序
 * @param arr 对象数组
 * @param str 要排序的字段
 * @returns 排列过的数组
 */
export const piOhSortList = (arr, str) => {
    // 数组排序
    if (Object.prototype.toString.call(arr).slice(8, -1) === "Array") {
        const returnArr = arr.sort(piOhCompare(str));
        return returnArr;
    }
    else {
        return arr;
    }
};
/**
 * 对象数组排序用到
 * @param property
 * @returns
 */
export const piOhCompare = (property) => {
    return function (a, b) {
        const value1 = a[property];
        const value2 = b[property];
        return value1 - value2;
    };
};
/**
 * 字符串是否是 json 数据
 * @param str 字符串
 * @returns boolean
 */
export const piOhIsJSON = (str) => {
    if (typeof str === "string") {
        try {
            const obj = JSON.parse(str);
            if (typeof obj === "object" && obj) {
                return true;
            }
            else {
                return false;
            }
        }
        catch (e) {
            return false;
        }
    }
    else {
        return false;
    }
};
/**
 * 字符串数字转 number类型
 * @param value
 * @returns
 */
export const piOhGetNumber = (value) => {
    if (typeof value === "string") {
        value = Number(value);
    }
    return value;
};
